import React from 'react';
import { accessSteps, productSpecs } from '../data/content';
import { Reveal } from './Reveal';
export function AccessDetails() {
  return <section className="bg-mint-50 py-20 sm:py-24" aria-labelledby="acceso-title" data-id="element-10" data-mp="3i6v4mv019pp6">
      <div className="mx-auto max-w-6xl px-6" data-id="element-11" data-mp="3da4ns5gemq2p">
        <Reveal className="max-w-2xl" data-id="element-12" data-mp="397q4jk8tpoaw">
          <h2 id="acceso-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-13" data-mp="398rgrs1ksgu7">
            Qué recibes exactamente y cómo accedes
          </h2>
          <p className="mt-4 text-lg text-ink-soft" data-id="element-14" data-mp="4trne4cv4g4z">
            Es un producto 100 % digital. Todo el contenido se entrega en archivos
            PDF: no se envían libros físicos.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-16" data-id="element-15" data-mp="3ryr2q624dfte">
          <Reveal delay={0.04} data-id="element-16" data-mp="2liorfjp1poza">
            <ol className="relative space-y-8 border-l border-mint-200 pl-8" data-id="element-17" data-mp="2lix4bbl64uah">
              {accessSteps.map((step, index) => <li key={step.title} className="relative" data-id="element-18" data-mp="2ghra19bv0yyu" data-mpi={index}>
                  <span className="absolute -left-[3.05rem] flex h-9 w-9 items-center justify-center rounded-full bg-mint-600 text-sm font-semibold text-white" aria-hidden="true" data-id="element-19" data-mp="1vwmpcch1vwd7">
                    {index + 1}
                  </span>
                  <h3 className="font-display text-xl text-ink" data-id="element-20" data-mp="1mvwxfjuwuq4r">{step.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-ink-soft" data-id="element-21" data-mp="1rtyey0couhe4">
                    {step.text}
                  </p>
                </li>)}
            </ol>
          </Reveal>

          <Reveal delay={0.08} data-id="element-22" data-mp="1hy54qnmfyzzi">
            <dl className="overflow-hidden rounded-3xl bg-white ring-1 ring-inset ring-mint-200" data-id="element-23" data-mp="1hyep9vopwext">
              {productSpecs.map(spec => <div key={spec.label} className="grid grid-cols-[8rem_minmax(0,1fr)] gap-4 border-b border-mint-100 px-6 py-4 last:border-b-0 sm:grid-cols-[10rem_minmax(0,1fr)]" data-id="element-24" data-mp="187a8cqfhek0c">
                  <dt className="text-sm text-ink-muted" data-id="element-25" data-mp="u9lw26zhcl6w">{spec.label}</dt>
                  <dd className="text-[15px] font-medium text-ink" data-id="element-26" data-mp="z62ld4if15lk">{spec.value}</dd>
                </div>)}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>;
}